module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 5
// module chunks = 0